import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import TableKeys from '../components/Table/ConfigurationTable'
import { StyledContainer } from '../styled'
import { KeyTableHead } from '../components/Table/data'

const Keys = ({
  keys,
  fetchData,
  isLoadingkeysList,
  pageLimitChanged,
  pageChanged,
  success,
  onCloseReset,
  keysCount,
  searchKeys,
  errorMessage,
  removeError,
  isErrorFetch,
  isSuccessRefresh,
  resetSuccessAction,
}) => {
  useEffect(() => {
    fetchData()
  }, [])

  useEffect(() => {
    if (success && isSuccessRefresh) {
      fetchData()
    }
    if (success || isSuccessRefresh) {
      resetSuccessAction()
    }
  }, [success])

  return (
    <>
      <StyledContainer>
        <TableKeys
          globalID={'Key'}
          searchData={searchKeys}
          searchPlaceholder={'Rechercher par clé'}
          tableHead={KeyTableHead}
          tableRows={keys}
          isKey={true}
          title={'Configuration des clés'}
          loadingData={isLoadingkeysList}
          actionButton={true}
          pageLimitChanged={pageLimitChanged}
          pageChanged={pageChanged}
          onCloseReset={onCloseReset}
          countData={keysCount}
          success={success}
          errorMessage={errorMessage}
          removeError={removeError}
          isErrorFetch={isErrorFetch}
          fetchData={fetchData}
          resetPagination={success && isSuccessRefresh}
        />
      </StyledContainer>
    </>
  )
}
Keys.propTypes = {
  keys: PropTypes.array,
  fetchData: PropTypes.func,
  isLoadingkeysList: PropTypes.bool,
  pageLimitChanged: PropTypes.func,
  pageChanged: PropTypes.func,
  searchKeys: PropTypes.func,
  keysCount: PropTypes.number,
  success: PropTypes.bool,
  onCloseReset: PropTypes.func,
  errorMessage: PropTypes.string,
  removeError: PropTypes.func,
  isErrorFetch: PropTypes.bool,
  isSuccessRefresh: PropTypes.bool,
  resetSuccessAction: PropTypes.func,
}
export default Keys
